import React from "react"
import { IconWrapper } from "../IconWrapper"
import {
  BodySubtextMedium,
  BodySubtextMiniMedium,
  BodyTextMedium,
} from "../typography/text"

interface BadgeProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  icon?: React.ReactNode
  isRound?: boolean
  badgeSize?: "small" | "medium" | "large"
  img?: React.ReactNode
}

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  (
    { icon, children, isRound, className, badgeSize = "large", img, ...rest },
    ref
  ) => {
    const TextComponent =
      badgeSize === "large"
        ? BodyTextMedium
        : badgeSize === "medium"
          ? BodySubtextMedium
          : BodySubtextMiniMedium

    return (
      <div
        ref={ref}
        className={`flex py-[2px] px-2 ${
          isRound ? "rounded-full" : "rounded-md"
        } flex-row gap-2 items-center min-w-fit w-fit ${
          className ? className : ""
        }`}
        {...rest}
      >
        {icon && <IconWrapper size={badgeSize}>{icon}</IconWrapper>}
        {img && img}
        <TextComponent
          className={`${badgeSize === "large" ? "!leading-6" : badgeSize === "medium" ? "!leading-5" : "!leading-4"}`}
        >
          {children}
        </TextComponent>
      </div>
    )
  }
)

Badge.displayName = "Badge"
